<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>QR Documento de Control Administrativo</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="qr-container">
    <div [innerHTML]="safeQrSvg"></div>
  </div>
  <div class="qr-help">
    <ion-button
      fill="outline"
      size="small"
      (click)="showQrHelp()"
    >
      <ion-icon
        aria-hidden="true"
        slot="start"
        src="../assets/material-symbols/help_24dp.svg"
      ></ion-icon>
      ¿Qué es esto?
    </ion-button>
  </div>
</ion-content>
